
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/trade-finance",
      function () {
        return require("private-next-pages/services/trade-finance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/trade-finance"])
      });
    }
  